import React, { useEffect, useState, useContext } from "react";
import {Message} from "coaz-ui";
import client from '../client';
import SubmitButton from "./SubmitButton";

const MobileTransaction = ({onSubmit,staticAmount}) => {
    const [loading, setLoading] = useState(true);
    const [amount, setAmount] = useState(0);
    const [message, setMessage] = useState({ content: "", success: false });
    const [disableAmount,setDisableAmount] = useState(false);
    const { errorMessage } = client;

    const [phoneNumber, setPhoneNumber] = useState({
        part1: "260",
        part2: "",
        part3: "",
        part4: "",
    });

    const onAmount = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let value = e.target.value;
        if (isNaN(value)) {
            return;
        }
        setAmount(value);
    };

    const onPhoneNumber = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let value = e.target.value;
        if (isNaN(value)) {
            return;
        }
        setPhoneNumber({ ...phoneNumber, [e.target.name]: value });
    };

    const confirm = async () => {
		try {
			setMessage({ content: "", success: false });
			
			if (amount < 1) {
				setMessage({
					content: "Amount must be greater than 0",
					success: false,
				});
				return;
			}
			if (phoneNumber.part1 === "") {
				setMessage({ content: "Invalid phone number", success: false });
				return;
			}
			if (phoneNumber.part2 === "") {
				setMessage({ content: "Invalid phone number", success: false });
				return;
			}
			if (phoneNumber.part3 === "") {
				setMessage({ content: "Invalid phone number", success: false });
				return;
			}
			if (phoneNumber.part4 === "") {
				setMessage({ content: "Invalid phone number", success: false });
				return;
			}
			let number =
				phoneNumber.part1 +
				phoneNumber.part2 +
				phoneNumber.part3 +
				phoneNumber.part4;

			setLoading(true);

			const response = await onSubmit(number,amount);
			
			if (response && response.ref) {
				setMessage({
					content: "Payment sent for processing",
					success: true,
				});
			} else {
				setMessage({content: errorMessage(response), success: false});
			}
		} catch (error) {
			setMessage({content: errorMessage(error), success: false});
		} finally {
			setLoading(false);
		}
    };

    useEffect(() => {
        if(staticAmount !== null && staticAmount !== undefined) {
            setAmount(staticAmount);
            setDisableAmount(true);
        }
		setLoading(false);
    },[staticAmount])

    return (
        <div className="flex items-center justify-center w-full h-full overflow-hidden">
            <div
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        confirm(e);
                    }
                }}
                style={{ backdropFilter: "blur(20px)" }}
                className="flex flex-col w-[95%] sm:w-[640px] h-[420px] bg-[rgba(255,255,255,.5)] items-center rounded-xl shadow-md overflow-hidden"
            >
                <div className="flex flex-col w-full p-8 space-y-6 h-fit">
                    <div className="flex flex-row justify-between w-full h-fit">
                        <div className="w-24 h-24 p-2 overflow-hidden rounded-3xl">
                            <img
                                src="/images/airtel.png"
                                alt="Airtel"
                                className="object-contain object-center w-full h-full"
                            />
                        </div>
                        <div className="w-24 h-24 p-2 overflow-hidden rounded-3xl">
                            <img
                                src="/images/mtn.png"
                                alt="Mtn"
                                className="object-contain object-center w-full h-full"
                            />
                        </div>
                        <div className="w-24 h-24 p-2 overflow-hidden rounded-3xl">
                            <img
                                src="/images/zamtel.png"
                                alt="Zamtel"
                                className="object-contain object-center w-full h-full"
                            />
                        </div>
                    </div>
                    <div className="flex flex-row items-center w-full text-sm text-text">
                        <label htmlFor="amount" className="w-1/3 capitalize">
                            Amount
                        </label>
                        <div className="flex flex-row items-center w-2/3 p-2 space-x-1 overflow-hidden">
                            <p className="flex w-11 shrink-0">ZMW</p>
                            <input
                                id="amount"
                                name="amount"
                                type="number"
                                inputMode="numeric"
                                value={amount}
                                onChange={onAmount}
                                disabled={disableAmount}
                                className={`flex w-full h-10 p-1 focus:outline-none font-thin whitespace-nowrap bg-white ${amount === "" || amount < 1 ? "border border-red-500" : ""} rounded-lg shadow-md`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-row items-center w-full text-sm text-text">
                        <label htmlFor="number" className="w-1/3 capitalize">
                            Phone number
                        </label>
                        <div className="flex flex-row items-center justify-between w-2/3 p-2 space-x-1 overflow-hidden">
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={3}
                                name="part1"
                                disabled={true}
                                value={phoneNumber.part1}
                                placeholder="000"
                                onChange={onPhoneNumber}
                                className={`flex w-full h-10 p-1 focus:outline-none font-thin whitespace-nowrap bg-white ${phoneNumber.part1 === "" ? "border border-red-500" : ""} rounded-lg shadow-md`}
                            />
                            <p className="">-</p>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={3}
                                name="part2"
                                value={phoneNumber.part2}
                                placeholder="000"
                                onChange={onPhoneNumber}
                                className={`flex w-full h-10 p-1 focus:outline-none font-thin whitespace-nowrap ${phoneNumber.part2 === "" ? "border border-red-500" : ""} rounded-lg shadow-md`}
                            />
                            <p className="">-</p>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={3}
                                name="part3"
                                value={phoneNumber.part3}
                                placeholder="000"
                                onChange={onPhoneNumber}
                                className={`flex w-full h-10 p-1 focus:outline-none font-thin whitespace-nowrap ${phoneNumber.part3 === "" ? "border border-red-500" : ""} rounded-lg shadow-md`}
                            />
                            <p className="">-</p>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={3}
                                name="part4"
                                value={phoneNumber.part4}
                                placeholder="000"
                                onChange={onPhoneNumber}
                                className={`flex w-full h-10 p-1 focus:outline-none font-thin whitespace-nowrap ${phoneNumber.part4 === "" ? "border border-red-500" : ""} rounded-lg shadow-md`}
                            />
                        </div>
                    </div>
                </div>
                <Message message={message} />
                <SubmitButton name="Confirm" onSubmit={confirm} width={240} loading={loading}/>
            </div>
        </div>
    );
};

export default MobileTransaction;
